import { render, staticRenderFns } from "./Portada.vue?vue&type=template&id=edab85d2&"
import script from "./Portada.vue?vue&type=script&lang=js&"
export * from "./Portada.vue?vue&type=script&lang=js&"
import style0 from "./Portada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports